import { api } from '../utils/apiClient';

export interface SubscriptionSummary {
  plan_code:
    | 'free'
    | 'starter'
    | 'team'
    | 'business'
    | 'enterprise_s'
    | 'enterprise_m'
    | 'enterprise_l';
  public_plan_code: 'free' | 'starter' | 'team' | 'business' | 'enterprise';
  plan_label: string;
  status: 'active' | 'trialing' | 'suspended' | 'cancelled' | 'past_due';
  billing_cycle: 'monthly' | 'annual' | 'custom' | null;
  billing_interval: 'monthly' | 'annual' | 'custom' | null;
  period_start: string;
  period_end: string;
  reset_date: string | null;
  test_selections_limit: number | null;
  test_selections_current: number;
  remaining_test_selections: number | null;
  overage_enabled: boolean;
  overage_selections_current: number;
  estimated_overage_charge_usd: number | null;
  services_limit: number | null;
  current_service_count: number;
  current_project_count: number;
  usage_warning: string | null;
  usage_percent: number | null;
  features: {
    functional_selection: boolean;
    chaos_selection: boolean;
    full_history: boolean;
    free_history_days: number | null;
  };
  project_limit?: number | null;
  run_limit?: number | null;
  run_count?: number;
  remaining_runs?: number | null;
}

export interface PlanSelectionResponse {
  status: 'selected' | 'checkout_required';
  selected_plan: 'free' | 'starter' | 'team' | 'business' | 'enterprise';
  message: string;
  subscription: SubscriptionSummary;
}

export const fetchSubscriptionSummary = async (): Promise<SubscriptionSummary> =>
  api.get<SubscriptionSummary>('/subscription/me');

export const selectSignupPlan = async (
  plan_code: 'free' | 'starter' | 'team' | 'business' | 'enterprise'
): Promise<PlanSelectionResponse> =>
  api.post<PlanSelectionResponse>('/subscription/select-plan', { plan_code });

export const switchTestOrganizationPlan = async (
  plan_code:
    | 'free'
    | 'starter'
    | 'team'
    | 'business'
    | 'enterprise_s'
    | 'enterprise_m'
    | 'enterprise_l'
): Promise<SubscriptionSummary> =>
  api.patch<SubscriptionSummary>('/subscription/test-plan', { plan_code });
